import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import { translate } from "react-polyglot";
import { Delete } from "./icons";
import { Button } from "./buttons";
import "./Modal.css";
import { FormContext } from "../context/form-context";

class Modal extends Component {
  static contextType = FormContext;

  constructor(props) {
    super(props);

    this.onAfterOpen = this.onAfterOpen.bind(this);
    this.onRequestClose = this.onRequestClose.bind(this);
  }

  onAfterOpen() {
    this.props.onAfterOpen();
  }

  onRequestClose() {
    this.props.onRequestClose();
  }

  render() {
    return (
      <FormContext.Consumer>
        {({ isDirty }) => {
          return (
            <ReactModal
              isOpen={this.props.isOpen}
              onAfterOpen={this.onAfterOpen}
              onRequestClose={this.onRequestClose}
              shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick}
              shouldFocusAfterRender={false}
              className={{
                base: this.props.className,
                afterOpen: "modal--after-open",
                beforeClose: "",
              }}
              overlayClassName={{
                base: "",
                afterOpen: "modal__overlay--after-open",
                beforeClose: "",
              }}
            >
              {this.props.showCloseButton && (
                <Button
                  tabIndex="0"
                  onKeyPress={this.onRequestClose}
                  onClick={this.onRequestClose}
                  className="modal__close-button"
                  ariaLabel={this.props.t("modal.close")}
                >
                  <Delete viewBox="8 8 16 16" />
                </Button>
              )}
              <div className="modal__header" />
              <div className="modal__contents">
                <div className="modal__contents-inner">
                  {this.props.children}
                </div>
              </div>
              <div className="modal__footer" />
            </ReactModal>
          );
        }}
      </FormContext.Consumer>
    );
  }
}

Modal.defaultProps = {
  onAfterOpen: () => {},
  shouldCloseOnOverlayClick: true,
  showCloseButton: true,
  className: "",
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onAfterOpen: PropTypes.func,
  onRequestClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  shouldCloseOnOverlayClick: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  className: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default translate()(Modal);



// WEBPACK FOOTER //
// ./src/components/Modal.js